import type { CategoryListItem } from '@/types/apis/Category';
import type { ClassValue } from 'clsx';

import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

import { cn } from '@/lib/utils';

type Props = {
  className?: ClassValue;
  content: CategoryListItem;
  link: string;
};

const ContentCategoryCard: React.FC<Props> = ({ className, content, link }) => {
  return (
    <Link href={link}>
      <div
        className={cn(
          'w-full relative aspect-[53/50] rounded-2xl overflow-hidden',
          className
        )}
      >
        {content.image && (
          <Image
            src={content.image}
            alt={content.title || 'Category'}
            fill
            sizes="(max-width: 768px) 100vw, 300px"
            className="object-cover"
          />
        )}
        <div className="h-full w-full right-0 absolute bottom-0 bg-linear-gradient-2" />
        <div className="h-full w-full flex justify-center items-center p-1">
          <p className="text-xs text-white font-bold text-center z-10">
            {content.title}
          </p>
        </div>
      </div>
    </Link>
  );
};

export default ContentCategoryCard;
